const suppressedWarnings = ["useSelect", "useEffect"];

const originalWarn = console.warn;
console.warn = (message, ...args) => {
  if (!suppressedWarnings.some((warning) => message.includes(warning))) {
    originalWarn(message, ...args);
  }
};
